import { Spinner } from 'reactstrap';
import { useDashboardInsights } from '../../hooks/useInsights';
import InsightCard from '../insights/InsightCard';
import InsightsLockedTeaser from '../insights/InsightsLockedTeaser';

export default function InsightsSection() {
    const { data, isLoading, isRegenerating } = useDashboardInsights();

    if (isLoading && !data) {
        return (
            <div className="d-flex justify-content-center py-3 mb-4">
                <Spinner size="sm" />
            </div>
        );
    }

    if (!data) return null;

    if (data.locked) {
        return <InsightsLockedTeaser teaserInsights={data.teaserInsights} />;
    }

    // Render the section even when there are no insights yet, so the regen
    // spinner has somewhere to show and first-time users see a placeholder.
    const insights = data.insights ?? [];
    const displayed = insights.slice(0, 4);
    const generatedFmt = data.generatedAt
        ? new Date(data.generatedAt).toLocaleDateString('en-GB', {
              day: 'numeric', month: 'short', year: 'numeric',
              hour: '2-digit', minute: '2-digit',
          })
        : null;

    return (
        <div className="mb-4">
            {insights.length > 0 ? (
                <div className="row g-3">
                    {displayed.map((insight, i) => (
                        <div key={i} className="col-sm-6 col-lg-3">
                            <InsightCard {...insight} />
                        </div>
                    ))}
                </div>
            ) : (
                <div className="border rounded p-4 text-center bg-light">
                    <h6 className="mb-2">No insights yet</h6>
                    <p className="text-muted small mb-0">
                        Add a few expenses or invoices and we'll generate AI insights about your margins, costs and revenue.
                    </p>
                </div>
            )}
            <div className="d-flex align-items-center justify-content-start gap-2 mt-2 small" style={{ minHeight: 18 }}>
                {isRegenerating ? (
                    <>
                        <Spinner size="sm" color="primary" />
                        <span className="text-primary">Refreshing insights&hellip;</span>
                    </>
                ) : generatedFmt ? (
                    <span className="text-muted">Updated {generatedFmt}</span>
                ) : null}
            </div>
        </div>
    );
}
